module.exports = __webpack_public_path__ + "static/media/gol_logo.6e1a8cec.png";